import { pipe, prop } from 'ramda';
import { selectLineByKey } from '../../store';

export const selectHasEventsIds = (lineKey) =>
  pipe(selectLineByKey(lineKey), prop('eventsIds'), Boolean);

export const selectHasEventsMarketsIds = (lineKey) =>
  pipe(selectLineByKey(lineKey), prop('eventsMarketsIds'), Boolean);
